<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tag</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col>
                                <b-form-group label="Tag:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            selectable
                            dataUrl="master-data/tags"
                            gridName="Danh sách Tag"
                            ref="tagTable">
                        <template v-slot:actions>
                            <router-link v-if="authorize(['ManageTag'])" to="/master-data/tags/create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <b-button v-if="authorize(['ManageTag'])" size="md" @click.stop="deletes" variant="danger" :disabled="isDisabledDelete">
                                Xóa
                            </b-button>
                        </template>
                        
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewTag'])" size="sm" :to="{ path: `./detail/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template>
                                    <b-button v-if="authorize(['ManageTag'])" size="sm" :to="{ path: `./edit/${row.item.id}` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageTag'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'Listtag',
        mixins: [authorizationMixin],
        data() {
            return {
                searchForm: {
                    str: null
                },
                isDisabledDelete: true,
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã Tag', sortable: true, sortDirection: 'asc' },
                        { key: 'name', label: 'Tên Tag', sortable: true, sortDirection: 'asc' },
                    ],
                    sortBy: 'id'
                },
            }
        },
        computed: {

        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.tagTable.selectedRows
                },
                (val) => {
                    this.isDisabledDelete = val.length == 0;
                }
            )
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.tagTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa Tag này?')) {
                    this.$services.delete(`master-data/tags/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa Tag thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.tagTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các Tag này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/tags?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa Tag thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn Tag cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
